import React, {useState} from "react";
import BreadcrumbsWrapper from "../../components/breadcrumbs/BreadcrumbsWrapper";
import {Container, HeaderWrapper, SelectWrapper} from "./Documentation.css";
import SwaggerUI from "swagger-ui-react";
import {Icon, Select, Tabs} from "@elcimai/webankdesignsystem";
import SwaggerCatalog from "./SwaggerManager";
import Sandbox from "./Sandbox";
import {getSingleValue} from "../../Utils";


function Oauth2Documentation(){
    const [currentTab, setCurrentTab] = useState(0);
    const catalog = SwaggerCatalog("OAUTH2");
    const [currentVersion, setCurrentVersion] = useState(catalog[0].value);


    const tabs = [
        {
            id: 0,
            texte: "Swagger",
            icon: <Icon icon="Puzzle" size={16} />,
            callback: () => setCurrentTab(0),
        },
        {
            id: 1,
            texte: "Sandbox",
            icon: <Icon icon="Box" size={16} />,
            callback: () => setCurrentTab(1),
        },
    ];

    SwaggerCatalog("OAUTH2")

    return(
        <div className={Container}>
            <BreadcrumbsWrapper/>
            <div className={HeaderWrapper}>
                <h1>Documentation OAuth2</h1>
                <div className={SelectWrapper}>
                    <Select name={"Version"} onChange={(value) => setCurrentVersion(getSingleValue(value))} options={catalog}
                            label={""} id={""} onBlur={undefined} value={currentVersion}/>
                </div>

            </div>

            <Tabs tabs={tabs}/>
            {(currentTab === 0) && (<SwaggerUI supportedSubmitMethods={[]} url={currentVersion}/>)}
            {(currentTab === 1) && (<Sandbox></Sandbox> ) }

        </div>
    )
}

export default Oauth2Documentation;